<div class="card mt-2">
  <div class="card-body">
    <h6 class="card-title">{{ pregunta.Descripcion }}</h6>

    <div *ngIf="pregunta.FlagDynamic" class="row">
      <div class="col">
        <span class="text-primary"> (Dinamica)</span>
      </div>
    </div>

    <hr />
    <div class="row row-cols-1" *ngFor="let respuesta of pregunta.Respuestas">
      <div class="col col-md-12">
        <div *ngIf="['radio'].includes(respuesta.Type)">
          <div class="custom-control custom-radio">
            <input
              disabled
              type="radio"
              id="relacion-{{ respuesta.IdRelacion }}"
              name="pregunta-{{
                pregunta.FlagDynamic
                  ? respuesta.IdPreguntaDinamica
                  : respuesta.IdPregunta
              }}"
              class="custom-control-input"
              bind-checked="respuesta.IdRevision > 0"
            />
            <label
              style="font-weight: 400"
              class="custom-control-label"
              for="relacion-{{ respuesta.IdRelacion }}"
              >{{ respuesta.Label }}</label
            >
          </div>
        </div>

        <div *ngIf="['checkbox'].includes(respuesta.Type)">
          <div class="custom-control custom-checkbox">
            <input
              disabled
              type="checkbox"
              id="relacion-{{ respuesta.IdRelacion }}"
              name="pregunta-{{
                pregunta.FlagDynamic
                  ? respuesta.IdPreguntaDinamica
                  : respuesta.IdPregunta
              }}"
              class="custom-control-input"
              bind-checked="respuesta.IdRevision > 0"
            />
            <label
              style="font-weight: 400"
              class="custom-control-label"
              for="relacion-{{ respuesta.IdRelacion }}"
              >{{ respuesta.Label }}</label
            >
          </div>
        </div>

        <div *ngIf="['text', 'number'].includes(respuesta.Type)">
          {{ respuesta.Label }}
          <input
            disabled
            class="form-control"
            type="{{ respuesta.Type }}"
            [value]="respuesta.Texto"
          />
        </div>

        <div *ngIf="['date'].includes(respuesta.Type)">
          {{ respuesta.Label }}
          <input
            disabled
            class="form-control"
            type="text"
            [value]="respuesta.Texto"
          />
        </div>
      </div>
      <div *ngIf="respuesta.Comentario != null" class="col col-md-6">
        <p>Comentario: {{ respuesta.Comentario }}</p>
      </div>
    </div>
    <app-evidencias
      [evidencias]="pregunta.Evidencias"
      *ngIf="pregunta.FlagEvidencia"
    >
    </app-evidencias>
  </div>
</div>
